import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { Router } from '@angular/router';
import { SafeUrlPipe } from '../safe-url.pipe';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


import {
  AlertController,
  IonRouterOutlet,
  LoadingController,
  ModalController,
  NavController,
  Platform,
  ToastController
} from '@ionic/angular';
import {StatusBar} from '@awesome-cordova-plugins/status-bar/ngx';
import {HomePage} from '../home/home.page';
import {Constant} from "../shared/model/Constant";
import {AuthService} from "../service/auth.service";
import {environment} from "../../environments/environment";
import { IntegrationService } from '../service/integration.service';


@Component({
  selector: 'app-main',
  templateUrl: './main.page.html',
  styleUrls: ['./main.page.scss'],
})

export class MainPage implements OnInit {

  data: any;
  user: any;
  text: any;
  subscription: any;
  today = new Date();
  userId: string;
  firstName: any;
  isAuthorized: string;
  logo = environment.logo;
  metabaseUrl: SafeResourceUrl;
  balanceData: any;


  constructor(private platform: Platform,
              private statusBar: StatusBar,
              private routerOutlet: IonRouterOutlet,
              public modalController: ModalController,
              public alertController: AlertController,
              private route: ActivatedRoute,
              public toastController: ToastController,
              private nav: NavController,
              public loadingController: LoadingController,
              private integrationService: IntegrationService,
              private sanitizer: DomSanitizer,
              private router: Router,

              private authService: AuthService) {
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem(Constant.userData));
    this.userId = JSON.parse(localStorage.getItem(Constant.userId));
    this.isAuthorized = localStorage.getItem(Constant.authorization);
    console.log(this.user, this.text);
    this.getUser();
    this.getStyles();
    this.loadMetabase();
    this.getBalance();
  }

  ionViewDidEnter() {
    this.loadData();
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.statusBar.overlaysWebView(false);
      this.statusBar.backgroundColorByHexString('#c82128');
      this.statusBar.styleLightContent();
    });

    this.subscription = this.platform.backButton.subscribe(() => {
      this.presentAlertConfirm();
    });
  }
/*
  getUser() {
    if (this.isAuthorized) {
      return;
    }
    this.authService.getUserById(this.userId).subscribe(value => {
      console.log(value);
    })
  }
*/
  ionViewWillLeave() {
    this.subscription.unsubscribe();
    this.statusBar.overlaysWebView(false);
    this.statusBar.backgroundColorByHexString('#f4f5f8');
    this.statusBar.styleDefault();
  }

  async presentAlertConfirm() {
    const alert = await this.alertController.create({
      header: this.text.exit_app,
      message: this.text.exit_app_desc,
      buttons: [
        {
          text: this.text.cancel,
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: this.text.exit_app_confirm,
          handler: () => {
            navigator['app'].exitApp();
          }
        }
      ]
    });
    await alert.present();
  }


  async loadData() {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
  }

  detail(invoice) {
    localStorage.setItem(Constant.invoiceData, JSON.stringify(invoice));
    this.nav.navigateForward('/idetail');
  }

  getStyles() {
    const userId = localStorage.getItem(Constant.userId);
    this.authService.getStyles(userId).subscribe((data: any) => {
      if (data && data.length > 0) {
        this.logo = data[0].logo ? data[0].logo : environment.logo;
      }
    }, error => {
      console.warn(error);
    });
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  loadMetabase() {
    const questionId = 1; 
    const userId = localStorage.getItem(Constant.userId); 
    this.integrationService.getMetabaseToken(questionId, userId).subscribe(token => {
      const urlMetabase = `https://analitica.yopresto.co/embed/question/${token}#bordered=true&titled=true`;
      this.metabaseUrl = this.getSafeUrl(urlMetabase);
      console.log(this.metabaseUrl); 

    });
  }

  goToPurchaseOrder() {
    this.router.navigate(['/purchaseOrder']);
  }

  goToListOrders() {
    this.router.navigate(['/listOrders']);
  }

  getUser() {
    console.log('Find user by id', this.userId);
    if (localStorage.getItem(Constant.userData1) && localStorage.getItem(Constant.userData1) != undefined) {
      this.user = JSON.parse(localStorage.getItem(Constant.userData));
    }
    if (this.isAuthorized === 'false') {
      return;
    }
    this.authService.getUserById(this.userId).subscribe((user) => {
      localStorage.setItem(Constant.userData1, JSON.stringify(user));
      this.user = user;
    });
  }

  getBalance(){
    const userId = localStorage.getItem(Constant.userId); 
    this.authService.getBalance(userId).subscribe(
      data => {
        this.balanceData = data;
        console.log('Datos del balance:', this.balanceData);
      },
      error => {
        console.error('Error al obtener el balance:', error);
      });
  }
}


